import { action, observable, makeObservable } from "mobx";
import { ServiceBase } from "../ServiceBase";
import { IJackpotsService } from "./jackpots.service.interface";
import { IServiceFactoryExtended } from "../service-factory-extended.interface";
import {NullableNumber} from "../../../common/types/nullable-types";

export class JackpotsService extends ServiceBase implements IJackpotsService {

    @observable
    public currentJackpotAmounts: Record<string, number | null> = {};

    constructor(serviceFactory: IServiceFactoryExtended) {
        super(serviceFactory);

        makeObservable(this);

        // this.updateCurrentJackpots(this.readJackpotsData(jackpotsWithState));
        this.subscribe();
    }

    /**
     * When the LIVE_FEEDS_JACKPOT_AMOUNTS_UPDATED from CGP is fired, the jackpots must be updated
     * The data in the event is of type Record<string, IJackpotDataByGame>
     */
    private subscribe() {
        this.services.sdk.events.onJackpotsAmountsUpdate((jackpotsAmounts: Record<string, unknown>) => {
            let amounts = Object.keys(jackpotsAmounts).reduce((accumulator, jpId) => {
                accumulator[jpId] = Number(jackpotsAmounts[jpId]);
                return accumulator;
            }, {});

            this.updateCurrentJackpots(amounts);
        });
    }

    @action.bound
    private updateCurrentJackpots(jackpots: Record<string, number>) {
        Object.keys(jackpots).forEach((jpId) => {
            this.currentJackpotAmounts[jpId] = jackpots[jpId];
        });
    }

    getGameJackpot(gameType: number): NullableNumber {
        return this.services.sdk.getJackpotAmountByGameType(gameType) || null;
    }
}